import axios from 'axios';
class userCourseService {
  getUserCourseProfileByCourseName(course_name, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/userCourses/${course_name}`, {
        method: 'GET',
        headers: {
          'token': token
        },
      })
        .then(data => resolve(data.json()))
        .catch(err => reject(err))
    })
  }
}

  export default userCourseService;